
import React from 'react';
import { Input } from "@/components/ui/input";
import { LabelWithChildren } from '@/components/ui/label-with-children';
import { AccountTypeSelector } from './AccountTypeSelector';

export interface AuthFormInputsProps {
  emailValue: string;
  passwordValue: string;
  setEmailValue: (value: string) => void;
  setPasswordValue: (value: string) => void;
  userType?: string;
  setUserType?: (value: string) => void;
  isSignUp?: boolean;
}

export const AuthFormInputs: React.FC<AuthFormInputsProps> = ({
  emailValue,
  passwordValue,
  setEmailValue,
  setPasswordValue,
  userType,
  setUserType,
  isSignUp,
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <LabelWithChildren htmlFor="email" className="text-sm font-medium text-gray-300">
          Email
        </LabelWithChildren>
        <Input
          id="email"
          placeholder="Enter your email"
          type="email"
          autoComplete="email"
          value={emailValue}
          onChange={(e) => setEmailValue(e.target.value)}
          className="bg-gray-700/60 text-gray-50 placeholder-gray-400 border-gray-600 focus-visible:ring-blue-500"
        />
      </div>
      
      <div className="space-y-2">
        <LabelWithChildren htmlFor="password" className="text-sm font-medium text-gray-300">
          Password
        </LabelWithChildren>
        <Input
          id="password"
          placeholder="Enter your password"
          type="password"
          value={passwordValue}
          onChange={(e) => setPasswordValue(e.target.value)}
          className="bg-gray-700/60 text-gray-50 placeholder-gray-400 border-gray-600 focus-visible:ring-blue-500"
        />
      </div>

      {isSignUp && userType !== undefined && setUserType !== undefined && (
        <AccountTypeSelector 
          accountType={userType} 
          setAccountType={setUserType} 
        />
      )}
    </div>
  );
};
